// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3HtDW","notes":"Notes_notes__1xtS8","note":"Notes_note__3vLX5","markdown":"Notes_markdown__tyal3"};